import React, {Fragment} from "react";
import Chart from "react-apexcharts";
import {Col, Container, Modal, Row} from "react-bootstrap";
import FullProfileModalBase from "./FullProfileModalBase";
import PlayerGoalInformation from "./performance_in_minutes_played_modal/PlayerGoalInformation";
import PlayerAssistInformation from "./performance_in_minutes_played_modal/PlayerAssistInformation";
import '../../../../../assets/sass/pages/full-profile/tabs/modals/performance-in-minutes-played-modal.scss';

import markWillsAvatar from '../../../../../assets/img/demo/mark-wills-avatar.png';
import shimronHetmyerAvatar from '../../../../../assets/img/demo/shimron-hetmyer-avatar.png';
import dustinWilliamsonAvatar from "../../../../../assets/img/demo/dustin-williamson-2-avatar.png";

class PerformanceInMinutesPlayedModal extends FullProfileModalBase {
    /**
     * Returns the chart series.
     * @param name {string} The name of series.
     * @param data {object} The y-values of series.
     * @returns {{data: *, name: *}} The cart series.
     * TODO: Complete Doc.
     */
    getSeries = (name, data) => {
        const step = 15;
        const offset = step / 2;

        return {
            name: name,
            data: data.map((value, index) => {
                const key = index * step + offset;
                return [key, value];
            })
        };
    };

    /**
     * Returns the config of chart.
     * @returns {{series: *, options: *}} The chart config.
     */
    chartConfig = () => {
        const series = [
            this.getSeries("Running", [69, 77, 88, 95, 111, 69]),
            this.getSeries("Attack", [52, 62, 77, 88, 107, 85]),
            this.getSeries("Defence", [85, 77, 62, 39, 55, 80]),
            this.getSeries("Shooting", [48, 39, 61, 80, 88, 55]),
            this.getSeries("Passing", [77, 85, 92, 99, 111, 107]),
        ];

        const options = {
            colors: ["#F2994A", "#2B82F7", "#BB6BD9", "#33A02C", "#899398"],
            legend: {
                position: 'top',
                floating: true,
            },
            chart: {
                type: 'bar',
                height: 220,
                selection: {
                    enabled: false,
                },
                toolbar: {
                    show: false,
                    offsetX: 0,
                    offsetY: 0,
                    tools: {
                        download: true,
                        selection: false,
                        zoom: false,
                    },
                    autoSelected: 'zoom'
                },
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '55%',
                    endingShape: 'rounded'
                },
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                show: true,
                width: 2,
                colors: ['transparent']
            },
            xaxis: {
                tickPlacement: 'on',
                tickAmount: 6,
                min: 0,
                max: 90,
            },
            yaxis: {
                show: false,
            },
            fill: {
                opacity: 1
            },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return val + "%"
                    }
                }
            }
        };

        return {
            series: series,
            options: options,
        }
    };

    /**
     * Render the components within the body of the modal.
     * @returns {React.ReactNode} The body of the modal.
     */
    renderBody = () => {
        return (
            <Fragment>
                {this.renderChart()}
                {this.renderGoalsAndAssists()}
            </Fragment>
        )
    };

    renderFooter = () => {
    };

    renderChart = () => {
        const chartConfig = this.chartConfig();
        const {options, series} = chartConfig;

        return (
            <div className="chart-container">
                <Chart options={options} series={series} type="bar" height={220}/>
            </div>
        );
    };


    renderGoalsAndAssists = () => {
        return (
            <Container fluid={true}>
                <Row>
                    <Col xs={6}> {this.renderGoals()} </Col>
                    <Col xs={6}> {this.renderAssists()} </Col>
                </Row>
            </Container>
        );
    };


    renderGoals = () => {
        return (
            <div className="goals">
                <div className="title">
                    Goals
                </div>
                <div className="players-list">
                    <PerformanceInMinutesPlayedModal.PlayerGoalInformation duration={62} name={"Shimron Hetmyer"} avatar={shimronHetmyerAvatar}/>
                    <PerformanceInMinutesPlayedModal.PlayerGoalInformation duration={62} name={"Mark Wills"} avatar={markWillsAvatar}/>
                </div>
            </div>
        )
    };

    renderAssists = () => {
        return (
            <div className="assist">
                <div className="title">
                    Assist
                </div>
                <div className="players-list">
                    <PerformanceInMinutesPlayedModal.PlayerAssistInformation name={"Dustin Williamson"} avatar={dustinWilliamsonAvatar}/>
                    <PerformanceInMinutesPlayedModal.PlayerAssistInformation name={"Mark Wills"} avatar={markWillsAvatar}/>
                    <PerformanceInMinutesPlayedModal.PlayerAssistInformation name={"Mark Wills"} avatar={dustinWilliamsonAvatar}/>
                </div>
            </div>
        )
    };

    /**
     * Returns default size of modal.
     * @returns {string} The modal size.
     */
    defaultSize = () => "md";

    /**
     * Returns classname of modal.
     * @returns {string} The classname modal.
     */
    modalClassname = () => "performance-in-minutes-played-modal";

    static defaultProps = {
        headerTitle: "Performance in Minutes Played",
        headerSubtitle: "90 of 90 | 100% Played",
    };
}

PerformanceInMinutesPlayedModal.PlayerGoalInformation = PlayerGoalInformation;
PerformanceInMinutesPlayedModal.PlayerAssistInformation = PlayerAssistInformation;
export default PerformanceInMinutesPlayedModal;
